import { LINK_ICALL, ONLINE_BOOKING, REVIEW_ON_CIAN, SUPERHOST } from 'shared/constants/links';
import { ERowType, TQuestion } from '../Answer/types';

export const LIST: TQuestion[] = [
  {
    id: 1,
    question: 'Как работает посуточная аренда на Циан?',
    answer: [
      {
        type: ERowType.String,
        text: 'Циан Посуточно — это сервис',
      },
      { type: ERowType.Link, text: 'онлайн-бронирования', url: ONLINE_BOOKING },
      {
        type: ERowType.String,
        text: 'с бесплатной страховкой ваших объектов и заботливой поддержкой. Публикация объявлений бесплатна, а комиссия Циан составляет 15% — она равна предоплате, которую вносит гость при бронировании',
      },
    ],
  },
  {
    id: 2,
    question: 'Какую недвижимость можно сдавать посуточно?',
    answer: [
      {
        type: ERowType.String,
        text: 'На Циан представлены категории: квартира, комната, дом, спальное место',
      },
    ],
  },
  {
    id: 3,
    question: 'Зачем мне размещаться на Циан, если я уже разместился на другой площадке?',
    answer: [
      {
        type: ERowType.String,
        text: 'Для вас это дополнительная реклама — ещё больше гостей увидят ваш объект, а значит вы получите больше бронирований. Для удобства вы можете синхронизировать календарь с другими площадками',
      },
      {
        type: ERowType.Link,
        text: 'через iCal',
        url: LINK_ICALL,
      },
      {
        type: ERowType.String,
        text: '— и все брони будут автоматически обновляться на Циан',
      },
    ],
  },
  {
    id: 4,
    question: 'Что делать, чтобы получать больше бронирований?',
    answer: [
      {
        type: ERowType.List,
        rows: [
          [
            {
              type: ERowType.String,
              text: 'Поддерживайте календарь бронирований в актуальном состоянии, и для удобства синхронизируйте его с другими площадками ',
            },
            {
              type: ERowType.Link,
              text: 'через iCal',
              url: LINK_ICALL,
            },
          ],
          [
            {
              type: ERowType.String,
              text: 'Получите специальные значки, которые привлекут внимание гостей: ',
            },
            {
              type: ERowType.Link,
              text: 'Проверено Циан',
              url: REVIEW_ON_CIAN,
            },
            {
              type: ERowType.String,
              text: ' и ',
            },
            {
              type: ERowType.Link,
              text: 'Суперхозяин',
              url: SUPERHOST,
            },
          ],
          [
            {
              type: ERowType.String,
              text: 'Размещайте актуальные фото, видео и описания объекта в соответствии с сезоном',
            },
          ],
          [
            {
              type: ERowType.String,
              text: 'Регулярно работайте с продвижением объявлений',
            },
          ],
        ],
      },
    ],
  },
];
